module.exports = __webpack_public_path__ + "static/media/mips_pipeline.9e3b3e69.png";